import { useState } from "react";
import { Avatar, Button, Input, Typography, Divider, Badge } from "antd";
import {
  HeartOutlined,
  HeartFilled,
  ShareAltOutlined,
  SendOutlined,
} from "@ant-design/icons";
import ClockImage from "../../assets/images/clock-image.svg";
import ShareImage from "../../assets/images/share-new-iconn.svg";
import LikeImage from "../../assets/images/like0icon--new.svg";
import ArrowsquareLeft from "../../assets/images/arrow-square-left.svg";
import ArrowUpImg from "../../assets/images/arrow-up-for-message.svg";
import { usePodcast } from "../../context/PodcastContext";
import { useParams } from "react-router-dom";
import Main from "../../components/layout/Main";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";
import { shareProfile } from "../../utils/share";
import ShareModal from "../../components/ShareModal";
import { getAudioDuration, getDifference } from "../../helper/functions";
import UniversalShareModal from "../../components/UniversalShareModal";
const profileImage = "https://avatar.iran.liara.run/public";

const PodcastDetailPage = () => {
  const [newComment, setNewComment] = useState("");
  const [podcast, setPodcast] = useState(null);
  const [comments, setComments] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);
  const [podcastDuration, setPodcastDuration] = useState();
  const closeComments = () => setCommentsOpen(false);
  const openComments = () => setCommentsOpen(true);
  const [commentsOpen, setCommentsOpen] = useState(true);
  const { year } = useParams();
  const {
    loadPostCastById,
    loadPodcastComments,
    writePodcastComment,
    addPodcastLike,
    removePodcastLike,
  } = usePodcast();
  const { id } = useParams();

  // ----------- handlers ------------
  const fetchPodcast = async () => {
    try {
      const response = await loadPostCastById(id);
      const result = await loadPodcastComments(id);
      setPodcast(response.data);
      setComments(result.data.comments);
      const duration = await getAudioDuration(response.data.audioUrl);
      setPodcastDuration(duration);
    } catch (error) {
      console.log("error-->", error);
    }
  };

  const handleComment = async (comment) => {
    try {
      await writePodcastComment(id, comment);
      fetchPodcast();
      setNewComment("");
    } catch (error) {
      console.log("error occured when comment submit ", error);
    }
  };

  const handleLike = async () => {
    try {
      if (podcast.isLiked) {
        await removePodcastLike(id);
      } else {
        await addPodcastLike(id);
      }
      fetchPodcast();
    } catch (error) {
      console.log("error occured when like submit ", error);
    }
  };

  // --------- use effect ---------
  useState(() => {
    fetchPodcast();
  }, []);

  // console.log("podcast-->", podcast);

  return (
    <Main>
      <div
        className={`podcast-detail-container ${
          commentsOpen ? "comments-open" : "comments-closed"
        }`}
      >
        {/* Left: Video & Info */}
        <div style={{ flex: 2 }}>
          <video
            poster={podcast?.coverImageUrl}
            src={podcast?.audioUrl}
            controls
            style={{
              width: "100%",
              height: "40%",
              borderRadius: 10,
              marginBottom: 16,
            }}
          />
          <div className="poadcast-view-under-video">
            <div className="poadcast-view-under-video-first">
              <h3>{podcast?.title}</h3>
              <h2>{podcast?.Author}</h2>
              <p>{podcast?.description}</p>
              <h5>
                <img src={ClockImage} alt="clock" /> {podcastDuration}
              </h5>
            </div>

            <div className="share-like-iconn">
              <h5>
                {podcast?.isLiked ? (
                  <>
                    <HeartFilled onClick={handleLike} />
                    Liked
                  </>
                ) : (
                  <>
                    <img src={LikeImage} onClick={handleLike} alt="Like" /> Like
                  </>
                )}
              </h5>

              <h5 onClick={() => setShareOpen(true)}>
                <img src={ShareImage} /> Share
              </h5>
            </div>
          </div>
        </div>

        {/* Right: Comments */}
        <div className="right-side-main-comment">
          <div className="right-side-main-comment-header">
            <div className="header-comment-count" onClick={closeComments}>
              <img src={ArrowsquareLeft} />
              Comments ({podcast?.totalComments})
            </div>

            <h4>
              {/* <img src={LikeImage} /> {podcast?.totalLikes} */}
              {podcast?.isLiked ? (
                <>
                  <HeartFilled onClick={handleLike} />
                </>
              ) : (
                <>
                  <img src={LikeImage} onClick={handleLike} alt="Like" />
                </>
              )}
              {podcast?.totalLikes}
            </h4>
          </div>

          <div className="comment-chat-section-body">
            {comments.map((comment, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  gap: 12,
                  marginBottom: 20,
                }}
              >
                <Avatar src={comment?.user?.profileImage || profileImage} />
                <div className="comment-chat-details">
                  <div className="comment-chat-details-message">
                    <h5>{comment?.user?.name || "Dummy Singh"}</h5>
                    <h2>{`${getDifference(comment?.createdAt)} `}</h2>
                  </div>
                  <p>{comment?.comment || "No comment found"}</p>
                </div>
              </div>
            ))}
            <div className="send-message-input">
              <Input
                placeholder="Write comment"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
                className="text-black-important"
              />
              <Button
                className="chat-send-button Fill-button"
                disabled={!newComment.trim()}
              >
                <img
                  src={ArrowUpImg}
                  onClick={() => handleComment(newComment)}
                />
              </Button>
            </div>
          </div>
          {!commentsOpen && (
            <div className="open-comments-btn" onClick={openComments}>
              <img src={ArrowsquareLeft} />
            </div>
          )}
        </div>
      </div>
      {/* Share Modal */}
      <UniversalShareModal
        open={shareOpen}
        onClose={() => setShareOpen(false)}
        url={window.location.href}
      />
    </Main>
  );
};

export default PodcastDetailPage;
